// Mock secrets: fixtures and the methods over them (in memory; a save bumps the rev, a remove marks it).
import { sleep } from "@/lib/utils";
import type { Api, SecretsData } from "../types";

export function secretsFixture(now: Date): SecretsData {
	const day = (n: number) => new Date(now.getTime() - n * 86_400_000).toISOString();
	const k1 = `age1${"q".repeat(54)}m1ke`;
	const k2 = `age1${"p".repeat(54)}b0ts`;
	return {
		recipients: [
			{ key: k1, names: ["Michael"] },
			{ key: k2, names: ["Agent"] },
		],
		secrets: [
			{ id: "sec_0000000001", profile: "default", key: "CLOUDFLARE_API_TOKEN", status: "active", rev: 2, changedAt: day(3), recipients: [k1, k2], reads: 14, lastReadAt: day(0), lastReadBy: { name: "Agent" } },
			{ id: "sec_0000000002", profile: "default", key: "CF_ACCOUNT_ID", status: "active", rev: 1, changedAt: day(9), recipients: [k1], reads: 3, lastReadAt: day(2), lastReadBy: { name: "Michael" } },
			{ id: "sec_0000000003", profile: "production", key: "S3_SECRET_ACCESS_KEY", status: "active", rev: 1, changedAt: day(1), recipients: [k1, k2], reads: 0, lastReadAt: null, lastReadBy: null },
		],
	};
}

export function mockSecrets(latency: number): Pick<Api, "secrets"> {
	const d = secretsFixture(new Date());
	return {
		secrets: {
			async list() {
				await sleep(latency);
				return structuredClone(d);
			},
			async save(_project, profile, key) {
				await sleep(latency);
				const row = d.secrets.find((s) => s.profile === profile && s.key === key && s.status === "active");
				const all = d.recipients.map((r) => r.key);
				const now = new Date().toISOString();
				if (row) Object.assign(row, { rev: (row.rev ?? 0) + 1, changedAt: now, recipients: all });
				else d.secrets.push({ id: `sec_mock${d.secrets.length}`, profile, key, status: "active", rev: 1, changedAt: now, recipients: all, reads: 0, lastReadAt: null, lastReadBy: null });
				return { rev: row?.rev ?? 1 };
			},
			async remove(_project, profile, key) {
				await sleep(latency);
				const row = d.secrets.find((s) => s.profile === profile && s.key === key);
				if (row) row.status = "removed";
			},
			// no ciphertexts here: a device set up in the mock reads nothing
			read: async () => JSON.stringify({ secrets: {} }),
			reseal: async () => 0,
			async addDevice(name, key) {
				const id = `dev_mock${d.recipients.length}`;
				d.recipients.push({ key, names: [`Michael \u00b7 ${name}`], device: id });
				return id;
			},
			async revokeDevice(id) {
				d.recipients = d.recipients.filter((r) => r.device !== id);
			},
		},
	};
}
